import { render, staticRenderFns } from "./RegionDistChart.vue?vue&type=template&id=3550747b&scoped=true"
import script from "./RegionDistChart.vue?vue&type=script&lang=js"
export * from "./RegionDistChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3550747b",
  null
  
)

export default component.exports